import React from "react";

const Terms = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-blue-50/30 to-white px-4 py-12 sm:px-6 sm:py-16">
      <article className="mx-auto max-w-4xl [overflow-wrap:anywhere] rounded-3xl border border-slate-200 bg-white p-6 text-slate-700 shadow-[0_18px_60px_rgba(15,23,42,0.07)] sm:p-10 [&_a]:break-words [&_a]:font-medium [&_a]:text-blue-700 [&_a]:underline-offset-4 [&_h2]:text-slate-950 [&_li]:leading-7 [&_p]:leading-7">
      <header className="mb-10 border-b border-slate-200 pb-7">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Legal</p>
        <h1 className="text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">Terms & Conditions</h1>
      </header>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">1. Introduction</h2>
        <p>
          JobZam® (UK Trademark No. <strong>UK00004249682</strong>). By accessing or using our platform,
          you agree to these Terms & Conditions. If you do not agree, please discontinue use
          of the service.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">2. User Accounts</h2>
        <p>
          You must be 16 years or older to create an account. You agree to provide accurate
          information and keep your account secure. We reserve the right to suspend or
          terminate accounts for suspicious, abusive, or fraudulent activity.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">3. Free Usage & Access Limits</h2>
        <p>
          Each user receives 3 free resume generations. After using the free limit, access to
          premium features requires a one-time purchase of either:
        </p>
        <ul className="list-disc ml-6 mt-2">
          <li><strong>30-Day Premium Access (one-time payment, no auto-renewal)</strong></li>
          <li><strong>3-Month Premium Access (one-time payment, no auto-renewal)</strong></li>
        </ul>
        <p className="mt-3">
          JobZam® does not offer monthly subscriptions or recurring billing. All payments are
          strictly one-time purchases for the chosen access period.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">4. Intellectual Property</h2>
        <p>
          All platform content—including the JobZam® name, logo, branding, AI-generated
          output, website design, and underlying code—is the intellectual property of
          Power Data Tech Ltd. You may not copy, reproduce, distribute, or create derivative
          works without written permission.
        </p>
        <p className="mt-3">
          <strong>Trademark Notice:</strong> JobZam® is a registered trademark in the United
          Kingdom (UK00004249682). Unauthorized use of our trademark—including bidding on
          “JobZam” as a keyword in advertising platforms (such as Google Ads), impersonation,
          passing off, or any misleading brand usage—is strictly prohibited and may lead to
          legal action under the UK Trade Marks Act 1994.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">5. Privacy & Data</h2>
        <p>
          We value your privacy. Please refer to our{" "}
          <a href="/privacy" className="text-blue-600 underline">Privacy Policy</a> to learn
          how we collect, store, and use your data.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">6. Liability</h2>
        <p>
          JobZam® provides AI-based tools “as-is” without guarantees of accuracy,
          job placement, or specific outcomes. We are not liable for missed job
          opportunities, data loss, business losses, or any indirect damages arising
          from use of the platform.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">7. Governing Law</h2>
        <p>
          These Terms & Conditions are governed by the laws of the United Kingdom.
          Any disputes shall be resolved under UK jurisdiction, regardless of your
          location.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-bold mb-2">8. Changes to Terms</h2>
        <p>
          We may update these Terms at any time. Continued use of JobZam® after updates
          indicates acceptance of the revised terms.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-2">9. Contact</h2>
        <p>
          For questions or support, reach us at{" "}
          <a href="mailto:team@jobzam.co" className="text-blue-600 underline">
            team@jobzam.co
          </a>.
        </p>
      </section>
      </article>
    </div>
  );
};

export default Terms;
